/**
 * Use on the main page `<h1>` only (max-lg). Clears the fixed app menu (left-4, h-11).
 * Body content should use normal `px-4` / `lg:px-6` — do not add this to filters, cards, etc.
 */
export const MOBILE_PAGE_TITLE_MENU_INSET =
  "max-lg:pl-[calc(env(safe-area-inset-left,0px)+1rem+2.75rem+0.75rem)] max-lg:pr-4";

/** Same as {@link MOBILE_PAGE_TITLE_MENU_INSET} with extra breathing room after the menu (Documents, etc.). */
export const MOBILE_PAGE_TITLE_MENU_INSET_COMFORT =
  "max-lg:pl-[calc(env(safe-area-inset-left,0px)+1rem+2.75rem+0.75rem+0.5rem)] max-lg:pr-4";

/**
 * Mobile-only top bars (`lg:hidden`) that sit under the floating menu — same clearance as
 * {@link MOBILE_PAGE_TITLE_MENU_INSET_COMFORT} but without `max-lg:` (parent already hides on large screens).
 */
export const MOBILE_HOME_DETAIL_HEADER_MENU_PL =
  "pl-[calc(env(safe-area-inset-left,0px)+1rem+2.75rem+0.75rem+0.5rem)]";

/**
 * `padding-top` for the Home mobile conversation/task header so the back row aligns with
 * the **top** of the fixed menu (`SideBar`: `0.75rem + 2.25rem·banners + 0.25rem` on `/`).
 * App shell `pt-*` for banners shifts the main content by the same `2.25rem` per row, so
 * those terms cancel — use `safe + 1rem` only.
 */
export function mobileHomeFloatingDetailHeaderPaddingTop(): string {
  return `calc(env(safe-area-inset-top, 0px) + 1rem)`;
}
